import React from "react";

function EmployeeDetails({
  object,
  clickView,
  clickEdit,
  clickDelete,
  isJobTitle,
}) {
  return (
    <div className="card mt-3 p-3 w-100 shadow-sm" style={{ fontSize: "12px" }}>
      <h6 className="fw-bold" style={{ color: "#d38740" }}>
        {object?.locations ? "Job Title Details" : "Job Post Details"}
      </h6>
      <p className="mb-1">
        <strong>Position Title:</strong> {object?.positionTitle}
      </p>
      <p className="mb-1">
        <strong>Slot Vacancy:</strong> {object?.slotVacancy}
      </p>
      <p className="mb-1">
        <strong>Date Posted:</strong>{" "}
        {object?.created
          ? new Date(object.created).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })
          : "N/A"}
      </p>
      <p className="mb-1">
        <strong>{object?.locations ? "Locations:" : "Location:"}</strong>{" "}
        {object?.locations
          ? object?.locations?.map((loc) => (
              <ul>
                <li style={{ marginBottom: "-15px" }}>{loc?.name}</li>
              </ul>
            ))
          : object?.location}
      </p>
      <p className="mb-1">
        <strong>Deadline:</strong>{" "}
        {new Date(object?.deadline).toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        })}
      </p>

      {/* Buttons */}
      <div className="mt-3">
        {isJobTitle ? (
          ""
        ) : (
          <button
            className="btn text-white w-100"
            style={{ backgroundColor: "#d18237" }}
            onClick={() => clickView()}
          >
            View Job Post
          </button>
        )}
      </div>
      <div className="d-flex justify-content-between mt-3">
        <button
          className="btn text-dark flex-grow-1 me-2"
          style={{ backgroundColor: "#e5e5e5" }}
          onClick={() => clickEdit()}
        >
          Edit
        </button>
        <button
          className="btn bg-danger text-white flex-grow-1"
          // style={{ backgroundColor: "#3f7cc0" }}
          onClick={() => clickDelete()}
        >
          Delete
        </button>
      </div>
    </div>
  );
}

export default EmployeeDetails;
